/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useContext } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";

// ------------------- CONSULTAS A LA API---------------------------
import { getEnlaceInscripcion, getProveedorPorID } from "../../API/Proveedores/ProveedoresRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import Loader from "../../Components/Loader/Loader";
import { getLabel } from "../../Services/Language/LanguageService";
import { formatCodigoProveedor } from "../../Services/Format";
import { FormatoInscripcionLang } from './FormatoInscripcionLang'
import { logoPPFBase64, firmaRevisado } from "../../Utils/Imagenes/Imgs";
import { getFirmaPersonalPublic } from "../../../Base/API/Firmas/FirmasRequests";
import { InscripcionProveedoresLang } from "./Lang/InscripcionProveedoresLang";
import { formatNumberDecimal } from "../../Services/FormatTemplate";
import { formatDate } from "../../../Base/Services/FechasService";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { obtenerNombreEmpresa } from "../../../Base/Utils/Funciones/Funciones";
import { getDateTimeString } from "../../Services/Moment/Luxon";



const FormatoInscripcionPDF = ({ setShowDialogFormato, showDialogFormato, selectedFormato, setSelectedFormato, Language, Token }) => {
  const [reporte, setReporte] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext)

  const obtenerInformacion = async () => {
    setLoading(true)
    let IdCustomer = selectedFormato?.IdCustomer
    let info
    if (Token) {
      info = await getProveedorPorID(IdCustomer, Token);
    } else {
      const TokenObt = await getEnlaceInscripcion(selectedFormato?.IdCustomer);
      info = await getProveedorPorID(IdCustomer, TokenObt);
    }
    if (info) {
      const firmaImg = await getFirmaPersonalPublic(info[0]?.idPersonal, Token);
      if (firmaImg) {
        generarPDF(info[0], Language, firmaImg);
      } else {
        generarPDF(info[0], Language, null);
      }
    }

    setLoading(false)
  };

  useEffect(() => {
    if (setShowDialogFormato) {
      obtenerInformacion();
    }
  }, [setShowDialogFormato]);


  
  const generarPDF = async (info, Language, Firma) => {
    const empresa = obtenerNombreEmpresa(info.FechaLlenoFormato ? new Date(info.FechaLlenoFormato) : new Date());
    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [30, 95, 30, 80],

      //HEADER
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            columns: [
              {
                image: logoPPFBase64?.logo,
                width: 200,
                margin: [4, -10, -10, -10],
              },

              [
                {
                  text: `ZONA LIBRE ${empresa.zonaLibreMayuscula} PERFORMANCE FABRICS`,
                  style: "titulo",
                  margin: [-10, 20, 0, 0],
                  width: 350,
                },
                {
                  text: "KM 19.5 CARRETERA A OCCIDENTE, LA ACEQUIA, NACO, QUIMISTÁN, SANTA BÁRBARA, HONDURAS.",
                  style: "titulo",
                  margin: [-10, 3, 0, 0],
                  width: 350,
                },
                {
                  text: "E-mail: info@ppf.com.hn",
                  style: "textBody1",
                  margin: [-10, 2, 0, 0],
                },
                {
                  text: "Teléfono: +504 2625-4400",
                  style: "textBody1",
                  margin: [-10, 2, 0, 0],
                },
              ],
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "codigoP",
                    Language
                  )} \n ${formatCodigoProveedor(info?.IdCustomer) || ""}`,
                  style: "numeroDoc",
                  width: 100,
                  margin: [0, 35, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      //FOOTER
      footer: (currentPage, pageCount) => {
        return [
          {
            text: `${getLabel(FormatoInscripcionLang, "textFinal", Language)}`,
            margin: [25, 10, 25, 0],
            fontSize: 8,
            alignment: "justify",
          },
          {
            text: `${getLabel(FormatoInscripcionLang, "textFinal1", Language)}`,
            margin: [25, 0, 25, 0],
            fontSize: 8,
          },
          {
            text: `Impreso: ${formatDate(new Date())}`,
            alignment: 'right',
            fontSize: 8,
            margin: [0, 0, 25, 0],
            width: '33%'
          }
        ];
      },

      //CONTENIDO
      content: [
        {
          columns: [
            {
              text: info?.FechaLlenoFormato
                ? `Fecha Lleno Formato: ${getDateTimeString(new Date(info.FechaLlenoFormato))}`
                : "",
              fontSize: 8,
              alignment: "left",
              width: "*",
            },
            {
              text: info?.UserRevisoFinanzas
                ? `Revisado Finanzas: ${info.UserRevisoFinanzas}`
                : "",
              fontSize: 8,
              alignment: "right",
              width: "*",
            },
          ],
          margin: [0, 0, 0, 5],
        },
        {
          columns: [
            {
              margin: [0, 0, 0, 0],
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "textInicial",
                        Language
                      )}`,
                      border: [false, true, false, true],
                      style: "subtitle",
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i) {
                  return 0.05;
                },
              },
            },
          ],
        },
        {
          columns: [
            {
              margin: [0, 5, 0, 0],
              table: {
                widths: ["15%", "33%", "2%", "33%", "2%", "15%"],
                body: [
                  [
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "tipoSolicitud",
                        Language
                      )}`,
                      border: [false, false, false, false],
                      style: "subtitle2",
                    },
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "inscripcion",
                        Language
                      )}`,
                      border: [false, false, false, false],
                      style: "subtitle3",
                    },
                    {
                      text: ``,
                      border: [true, true, true, true],
                      style: "subtitle2",
                    },
                    {
                      text: `${getLabel(
                        FormatoInscripcionLang,
                        "actualizacion",
                        Language
                      )}`,
                      border: [false, false, false, false],
                      style: "subtitle3",
                    },
                    {
                      text: ``,
                      border: [true, true, true, true],
                      style: "subtitle2",
                    },
                    {
                      text: ``,
                      border: [false, false, false, false],
                      style: "subtitle2",
                    },
                  ],
                ],
              },
              layout: {
                hLineWidth: function (i) {
                  return 0.05;
                },
                vLineWidth: function (i) {
                  return 0.05;
                },
              },
            },
          ],
        },

        // PARTE I
        {
          margin: [0, 15, 0, 0],
          style: "tableExample",
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "parteI",
                    Language
                  )}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  fillColor: "#0864cc",
                  color: "white", // Color del texto blanco
                },
              ],
            ],
          },
        },
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: ["55%", "3%", "42%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "casaMatriz",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${getLabel(FormatoInscripcionLang, "pais", Language)}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.CasaMatriz || (info?.CustomerName)}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Country || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],

              [
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "identificacionTributaria",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],

              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "nombre",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: `RTN/RUC/UTR/BRN/TAX ID`,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.NombreComercial || info?.CustomerName}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.RTN || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "direccionC",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
              ],
              [
                {
                  text: `${info?.DireccionCasaMatriz || info?.Address}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "nTel", Language)}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `No.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Tel || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `E-mail:`,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: `${info?.Email || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["8%", "41%", "12%", "39%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "contacto",
                    Language
                  )}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Nombre: `,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ContactoCuentasPorCobrar || ""}`,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.CorreoCuentasPorCobrar || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "representanteL",
                    Language
                  )}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Nombre: `,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.NombreRepresentanteLegal || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.CorreoRepresentanteLegal || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],

              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "actividad",
                    Language
                  )}`,
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `${info?.PrincipalActividadEconomica || ""}`,
                  colSpan: 4,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody2",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, true],
                  margin: [0, 3, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },

        // PARTE II
        {
          style: "tableExample",
          margin: [0, 20, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "parteII",
                    Language
                  )}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  margin: [0, 0, 0, 0],
                  fillColor: "#0864cc",
                  color: "white", // Color del texto blanco
                },
              ],
            ],
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  // text:
                  //   `${getLabel(
                  //     FormatoInscripcionLang,
                  //     "nombreC",
                  //     Language
                  //   ) + ': ' + info?.ref1Nombre}`

                  // ,
                  text: [
                    { text: `${getLabel(FormatoInscripcionLang, "nombreC", Language) + ': '}`, },
                    { text: `${info?.ref1Nombre}`, bold: false }
                  ],
                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref1Nombre}`,
                  style: "textBody1", bold: false,
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Tel.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref1Telefono || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref1Correo || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["5%", "44%", "12%", "39%"],
            body: [
              [
                {
                  text: [
                    { text: `${getLabel(FormatoInscripcionLang, "nombreC", Language) + ': '}`, },
                    { text: `${info?.ref2Nombre}`, bold: false }
                  ],

                  colSpan: 2,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 8, 0, 0],
                },
                {
                  text: ``,
                  style: "textBody1",
                  margin: [0, 8, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                {
                  text: `Tel.`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref2Telefono || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `E-mail: `,
                  style: "textBody2",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
                {
                  text: `${info?.ref2Correo || ""}`,
                  style: "textBody5",
                  border: [false, false, false, true],
                  margin: [0, 5, 0, 0],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea horizontal
            },
            vLineWidth: function (i) {
              return 0.03; // Establecer grosor de línea vertical
            },
          },
        },

        // PARTE III
        {
          margin: [0, 20, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "parteIII",
                    Language
                  )}`,
                  style: "subtitle",
                  border: [false, false, false, false],
                  margin: [0, 0, 0, 0],
                  fillColor: "#0864cc",
                  color: "white", // Color del texto blanco
                },
              ],
            ],
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["100%"],
            body: [
              [
                {
                  text: `${getLabel(
                    FormatoInscripcionLang,
                    "text3",
                    Language
                  )}`,
                  style: "textBody1",
                  border: [false, false, false, false],
                  margin: [0, 5, 0, 0],
                },
              ],
            ],
          },
        },


        info?.IdPaisCuentaBancaria === 95
          ? {
            margin: [0, 5, 0, 0],
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "bancoNacional",
                      Language
                    )}`,
                    style: "subtitle",
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 0],
                  },
                ],
              ],
            },
          }
          : null,
        info?.IdPaisCuentaBancaria === 95
          ? {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["30%", "70%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "cuentaBancariaNacional",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: `${info?.NumeroCuentaBancaria || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 0, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "aNombreDe",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.TitularCuenta || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "Banco",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.Banco || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "RTN",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.RTN || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                    // pageBreak: "after",
                  },
                ],
                [
                  { text: '' },
                  {
                    text: ``,//style: "textBody5",
                    pageBreak: "after",
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "tipoCuenta",
                      Language
                    )}`,
                    style: "textBody1",

                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.TipoCuenta || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "Moneda",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.CurrencyNanme || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "CorreoNotificacionPago",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.CorreoCuentasPorCobrar || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "TelefonoSmall",
                      Language
                    )}`,
                    style: "textBody1",
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.TelefonoCuentasPorCobrar || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
                ![1, 2].includes(info?.IdBanco) ?
                  [
                    // {
                    //   text: `${getLabel(
                    //     FormatoInscripcionLang,
                    //     "opcionPago",
                    //     Language
                    //   )}`,
                    //   style: "textBody1",
                    //   border: [false, false, false, false],
                    //   margin: [0, 5, 0, 0],
                    // },
                    info?.DeduccionACH ? {
                      text: `************** ${getLabel(InscripcionProveedoresLang, 'Acepto', Language)}  **************`, style: "textBody1", alignment: 'center',
                      margin: [0, 10, 0, 0], border: [false, false, false, false], colSpan: 2
                    }
                      : (info?.PagarCheque ? {
                        text: `************** ${getLabel(InscripcionProveedoresLang, 'PagarCheque', Language)} **************`, alignment: 'center', style: "textBody1", border: [false, false, false, false],
                        margin: [0, 10, 0, 0], colSpan: 2
                      } : { text: '' }),
                    { text: '' },
                  ]

                  : [{ text: '' }, { text: '' }]
              ],
            },
            layout: {
              defaultBorder: false,
              hLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea vertical
              },
            },
          }
          : null,

        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 10, 0, 0],
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "bancoI",
                      Language
                    )}`,
                    style: "subtitle",
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 0],
                  },
                ],
              ],
            },
          }
          : null,
        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["15%", "85%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "nombreB",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: `${info?.BancoIntermediarioNombre || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 0, 0, 0],
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "direccionB",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoIntermediarioDireccion || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "numeroCuenta",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoIntermediarioCuenta || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea vertical
              },
            },
          }
          : null,
        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["5%", "44%", "11%", "40%"],
              body: [
                [
                  {
                    text: `Swift:`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoIntermediarioSwift || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `ABA: `,
                    style: "textBody2",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoIntermediarioAbaBin || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea vertical
              },
            },
          }
          : null,
        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 50, 0, 0],
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "bancoB",
                      Language
                    )}`,
                    style: "subtitle",
                    border: [false, false, false, false],
                    margin: [0, -5, 0, 0],
                  },
                ],
              ],
            },
          }
          : null,
        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["18%", "82%"],
              body: [
                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "nombreBeneficiario",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 0, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioNombreBeneficiario || ""
                      }`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 0, 0, 0],
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "nombreB",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioNombre || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "direccionB",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioDireccion || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],

                [
                  {
                    text: `${getLabel(
                      FormatoInscripcionLang,
                      "numeroCuenta",
                      Language
                    )}`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioCuenta || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea vertical
              },
            },
          }
          : null,
        info?.IdPaisCuentaBancaria !== 95
          ? {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["5%", "44%", "11%", "40%"],
              body: [
                [
                  {
                    text: `Swift:`,
                    style: "textBody1",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioSwift || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `ABA: `,
                    style: "textBody2",
                    border: [false, false, false, false],
                    margin: [0, 5, 0, 0],
                  },
                  {
                    text: `${info?.BancoBeneficiarioAbaBin || ""}`,
                    style: "textBody5",
                    border: [false, false, false, true],
                    margin: [0, 5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea horizontal
              },
              vLineWidth: function (i) {
                return 0.03; // Establecer grosor de línea vertical
              },
            },
          }
          : null,
        //PARTE IV
        {
          // style: "tableExample",
          // style: "textBody1",
          style: 'tables2',
          margin: [0, 20, 0, 0],
          table: {
            widths: [80, '*', 70, '*'],
            body: [
              [
                {
                  text: `${getLabel(FormatoInscripcionLang, "parteIV", Language)}`,
                  style: "subtitle", border: [false, false, false, false],
                  fillColor: "#0864cc", color: "white", colSpan: 4
                }, {}, {}, {}
              ],

              [
                {
                  text:
                    [
                      { text: `${getLabel(FormatoInscripcionLang, "Moneda", Language) + ':  '}`, bold: true },
                      { text: ` ${info?.MonedaFin || ''}` }
                    ]
                  ,
                  colSpan: 4, margin: [0, 5, 0, 0],
                },
                {}, {}, {},
              ],
              [
                { text: `${getLabel(FormatoInscripcionLang, 'ActivoCorriente', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatNumberDecimal(info?.ActivosCorrientes)}`, border: [false, false, false, true], alignment: 'center', margin: [0, 5, 0, 0], },
                { text: `${getLabel(FormatoInscripcionLang, 'TotalActivo', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatNumberDecimal(info?.TotalActivos)}`, border: [false, false, false, true], alignment: 'center', margin: [0, 5, 0, 0], }
              ],
              [
                { text: `${getLabel(FormatoInscripcionLang, 'PasivoCorriente', Language)}: `, style: "textBody1", margin: [0, 5, 0, 0], },
                { text: `${formatNumberDecimal(info?.PasivosCorrientes)}`, border: [false, false, false, true], alignment: 'center', margin: [0, 5, 0, 0], },
                { text: `${getLabel(FormatoInscripcionLang, 'TotalPasivo', Language)}: `, bold: true, margin: [0, 5, 0, 0], },
                { text: `${formatNumberDecimal(info?.TotalPasivos)}`, border: [false, false, false, true], alignment: 'center', margin: [0, 5, 0, 0], }
              ],
            ],

          },
          layout: {
            defaultBorder: false,
            hLineWidth: function (i) {
              return 0.05;
            },
          }

        },
        info?.IdCountry === 95 ?
          [
            //Parte V
            {
              // style: "tableExample",
              style: "textBody1",
              margin: [0, 25, 0, 0],
              table: {
                widths: [80, '*', 50, '*'],
                body: [
                  [
                    {
                      text: `${getLabel(FormatoInscripcionLang, "parteV", Language)}`,
                      style: "subtitle", border: [false, false, false, false], margin: [0, 0, 0, 0], fillColor: "#0864cc", color: "white", colSpan: 4
                    },
                    { text: '' }, { text: '' }, { text: '' }
                  ],

                ],

              },
              layout: {
                defaultBorder: false,
                hLineWidth: function (i) {
                  return 0.05;
                },
              },
            },

            info?.ZonaLibre ?
              (info?.SinRegistroExonerado ?
                {
                  text: `${getLabel(InscripcionProveedoresLang, "msjZonaLibre", Language)}`, margin: [10, 5, 10, 0], alignment: 'center', style: "textBody1", lineHeight: 1.5
                }
                :
                {

                  margin: [0, 10, 0, 0],
                  style: 'tables2',
                  table: {
                    widths: [60, 50, '*', 45, 70, 70, 70],
                    body: [
                      [
                        { text: `${getLabel(InscripcionProveedoresLang, "RegistroExonerado", Language)}:`, colSpan: 2, style: "textBody1", margin: [0, 5, 0, 0] }, {},
                        { text: `${info?.RegistroExonerado}`, border: [false, false, false, true], style: 'textBody1SinBold', margin: [0, 5, 0, 0], alignment: 'center' },
                        { text: `${getLabel(InscripcionProveedoresLang, "FechaInicio", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0], },
                        { text: `${info?.StartDate || ''}`, border: [false, false, false, true], style: 'textBody1SinBold', alignment: 'center', margin: [0, 5, 0, 0], },
                        { text: `${getLabel(InscripcionProveedoresLang, "FechaVencimiento", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0], },
                        { text: `${info?.ExpiredDate || ''}`, border: [false, false, false, true], style: 'textBody1SinBold', alignment: 'center', margin: [0, 5, 0, 0], }
                      ],
                      [
                        { text: `${getLabel(InscripcionProveedoresLang, "nombreZona", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                        { text: `${info?.NombreZona || ''}`, colSpan: 6, border: [false, false, false, true], style: 'textBody1SinBold', margin: [0, 5, 0, 0] },
                        {}, {}, {}, {}, {},
                      ],
                      [

                        { text: `${getLabel(InscripcionProveedoresLang, "direccionZona", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0] },
                        { text: `${info?.DireccionZona || ''}`, colSpan: 6, border: [false, false, false, true], style: 'textBody1SinBold', margin: [0, 5, 0, 0] },
                        {}, {}, {}, {}, {},
                      ]

                    ]
                  },
                  layout: {
                    defaultBorder: false,
                    hLineWidth: function (i) {
                      return 0.05;
                    }
                  }


                }

              )
              : (

                !info?.TieneConstPagosCuenta ?
                  {
                    text: `${getLabel(InscripcionProveedoresLang, "msjZonaLibre", Language)}`, margin: [10, 5, 10, 0], alignment: 'center', style: "textBody1", lineHeight: 1.5,
                  }
                  :
                  {

                    margin: [0, 10, 0, 0],
                    style: 'tables2',
                    table: {
                      widths: [50, 150, '*', 70, 150],
                      body: [
                        [

                          { text: `${getLabel(InscripcionProveedoresLang, "tieneConstanciaPagos", Language)}`, colSpan: 5, bold: true }, { text: '' }, { text: '' }, { text: '' }, { text: '' }
                        ],
                        [
                          { text: `${getLabel(InscripcionProveedoresLang, "FechaInicio", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0], },
                          { text: `${info?.StartDate || ''}`, border: [false, false, false, true], style: 'textBody1SinBold', alignment: 'center', margin: [0, 5, 0, 0], },
                          { text: '' },
                          { text: `${getLabel(InscripcionProveedoresLang, "FechaVencimiento", Language)}:`, style: "textBody1", margin: [0, 5, 0, 0], },
                          { text: `${info?.ExpiredDate || ''}`, border: [false, false, false, true], style: 'textBody1SinBold', alignment: 'center', margin: [0, 5, 0, 0], }
                        ],


                      ]
                    },
                    layout: {
                      defaultBorder: false,
                      hLineWidth: function (i) {
                        return 0.05;
                      }
                    }


                  }
              ),
          ]
          : null,


        {
          margin: [0, 80, 0, 0],
          columns: [
            { width: "*", text: "" },
            {
              width: "auto",
              stack: [

                {
                  text: "__________________________________________",
                  alignment: "center",
                  border: [false, false, false, false],
                },
                {
                  text: `${info?.CustomerName ?  info?.CustomerName : info?.NombreComercial}`,
                  alignment: "center",
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                },
              ],
            },
            { width: "*", text: "" },
          ],
        },
        userAuth?.idUser ? 
        info?.UsuarioReviso && {
          margin: [0, 80, 0, 0],
          columns: [
            { width: "*", text: "" },
            {
              width: "auto",
              stack: [
                // Firma específica si es el usuario es 435 (Mirella Dubon)
                ...(parseInt(info?.IdUsuarioRevision) === 435 && firmaRevisado?.firma
                  ? [
                    {
                      image: firmaRevisado?.firma,
                      width: 70,
                      alignment: "center",
                    },
                  ]
                  :
                  Firma
                    ? [
                      {
                        image: `data:image/png;base64,${Firma}`,
                        width: 150,
                        alignment: "center",
                      },
                    ]
                    : []

                ),
                {
                  text: "__________________________________________",
                  alignment: "center",
                  border: [false, false, false, false],
                },
                {
                  text: `${info.UsuarioReviso || "Nombre de quien autoriza"}`,
                  alignment: "center",
                  style: "textBody1",
                  margin: [0, 5, 0, 0],
                },
              ],
            },
            { width: "*", text: "" },
          ],
        } : null
      ],

      // ESTILOS
      styles: {
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        titulo: {
          fontSize: 8,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        requisa: {
          fontSize: 15,
          // margin: [0, 50, 0, 0],
          bold: true,
          alignment: "justify",
        },
        numeroDoc: {
          fontSize: 12,
          bold: true,
          alignment: "center",
        },
        subtitle: {
          fontSize: 8,
          bold: true,
          alignment: "center",
        },
        subtitle2: {
          fontSize: 8,
          bold: true,
        },
        subtitle3: {
          fontSize: 8,
          bold: true,
          alignment: "right",
        },
        infoGeneral: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
          // bold: true,
          // alignment: 'justify'
        },
        infoProveedor: {
          fontSize: 8,
          margin: [0, 0, 0, 0],
        },
        header: {
          fontSize: 6.5,
          alignment: "center",
          bold: true,
        },
        headerr: {
          fontSize: 7,
          margin: [-5, 0, 0, 0],
        },
        textBody1: {
          fontSize: 7.5,
          bold: true,
          // alignment: "center",
          // lineHeight: 2
        },
        textBody5: {
          fontSize: 7.5,
          // alignment: "center",
          // lineHeight: 2
        },
        textBody2: {
          fontSize: 7.5,
          alignment: "right",
          bold: true,
          // lineHeight: 2
        },
        textBody3: {
          fontSize: 7.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textBody4: {
          fontSize: 8.5,
          alignment: "justify",
          // lineHeight: 2
        },
        textTotales: {
          bold: true,
          fontSize: 7.5,
          alignment: "right",
        },
        textCentrado: {
          fontSize: 7.5,
          alignment: "center",
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
        textBody1SinBold: {
          fontSize: 7.5,

        },
        tables2: {
          fontSize: 7.5,
          // lineHeight: 1.8,
        }
      },
    };

    // const empresa = obtenerNombreEmpresa(info?.FechaRevision || new Date());
    // const empresa = obtenerNombreEmpresa(info?.FechaRevision || new Date());
    const doc = pdfMake.createPdf(docDefinition);

    doc.getDataUrl((url) => {
      setReporte(url);
    })
  };

  const onHideReporte = () => {
    setShowDialogFormato(false)
    setSelectedFormato(null)
  }

  return (
    <Dialog
      visible={showDialogFormato}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Toast ref={toast} />

      {loading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%", height: "100%" }}>
          <Loader loading={loading} querySelector={"#Modal"} />
        </div>
      ) : (
        <div id="Modal">
          {!loading && reporte && (
            <iframe
              src={reporte}
              style={{ width: "60vw", height: "75vh" }}
              id="foo"
              title="Reporte QR PDF"
            />
          )}
        </div>
      )}
    </Dialog>
  );
};

export default FormatoInscripcionPDF;
